import { memoize } from 'lodash/fp';
import { cloneElement, Component, isValidElement } from 'react';

import styled from 'styled-components';
import { ExpandableListItemProps } from '../ExpandableListItem';
import { List } from '../List';
import toFlatChildrenArray from '../utils/toFlatChildrenArray';

interface ExpandableListProps {
    depth: number;
    multiSelect: boolean;
}

interface ExpandableListState {
    expandedValues: Array<string | number>;
}

type ChildProps = Pick<ExpandableListItemProps, 'onClick' | 'opened' | 'depth' | 'value'>;

/**
 * @deprecated use Accordion
 */
export class ExpandableList extends Component<React.PropsWithChildren<ExpandableListProps>, ExpandableListState> {
    static defaultProps = { depth: 0, multiSelect: false };

    readonly state: ExpandableListState = {
        expandedValues: [],
    };

    handleExpandableBoxClick = memoize((value: string | number) => () => {
        let { expandedValues } = this.state;
        if (expandedValues.includes(value)) {
            expandedValues = expandedValues.filter((v) => v !== value);
        } else {
            expandedValues = this.props.multiSelect ? [...expandedValues, value] : [value];
        }

        this.setState({ expandedValues });
    });

    render() {
        const { children, depth, ...other } = this.props;
        const flatChildren = toFlatChildrenArray(children);
        const items = flatChildren.map((child) => {
            if (!isValidElement<ChildProps>(child)) {
                return child;
            }

            const { value } = child.props;

            return cloneElement(child, {
                onClick: this.handleExpandableBoxClick(value),
                opened: this.state.expandedValues.includes(value),
                depth,
            });
        });

        return <ListWithoutPadding {...other}>{items}</ListWithoutPadding>;
    }
}

// Since this is a deprecated component, we opted for removing the padding here to fix some styles in commander
// TODO: Remove this component from the codebase and refactor its instances
const ListWithoutPadding = styled(List)`
    padding: 0;
`;
